const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #df2800;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_110",
  "data-name": "Ellipse 110",
  className: "cls-1",
  cx: 39,
  cy: 39,
  r: 39
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1260",
  "data-name": "Rectangle 1260",
  className: "cls-2",
  width: 8,
  height: 35,
  transform: "translate(36 16)"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_113",
  "data-name": "Ellipse 113",
  className: "cls-2",
  cx: 4,
  cy: 4,
  r: 4,
  transform: "translate(36 57)"
});
function SvgOrderSummaryError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Yes",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSummaryError);
export default __webpack_public_path__ + "static/media/order-summary-error.030e14348f9421b74b66e35cbb16b207.svg";
export { ForwardRef as ReactComponent };